<!-- welcome section starts -->
<app-loader [loading]="loading" [overlayState]="overlayState"></app-loader>
<div class="container-fluid" style="background: var(--surface-surface-secondary, #F5F5F5);">
  <div class="container homepage-top-section">
    <div class="row">
      <div class="col-md-4 d-flex order-2 order-sm-2 order-md-2 order-lg-1 justify-content-center align-items-center">
        <img src="../assets/images/water-tower-wb.png" alt="Welcome Image" class="img-fluid" style="height: auto;">
      </div>
      <div class="col-md-8 d-flex  order-1 order-sm-1 order-md-1 order-lg-2 justify-content-center align-items-center">
        <div class="welcome-note">
          <h1 class="homepage-greeting-msg">
            {{constants.title}}
          </h1>
          <p class="homepage-greeting-submsg">
            {{constants.description}} <b class="bold-text">{{constants.description1}}</b>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- welcome section ends -->
<!-- center section starts -->

<div class="container services-block">
  <div class="row">
    <div class="col-lg-4 col-md-12 col-sm-12 site-resource-section">
      <div class="d-flex align-items-center site-resource-icon-wrapper">
        <img src="../assets/images/handbook.svg" alt="Handbook icon" class="me-3">
        <h2>{{constants.sectionTitle1}}</h2>
      </div>
      <div class="site-resource-more-info">
        <p class="site-resource-info-text">{{constants.subtitle1}}</p>
        <a routerLink="/core/wbso-handbook" class="text-link">{{constants.link1}}</a>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 site-resource-section">
      <div class="d-flex align-items-center site-resource-icon-wrapper">
        <img src="../assets/images/maps.svg" alt="Handbook icon" class="me-3">
        <h2>{{constants.sectionTitle2}}</h2>
      </div>
      <div class="site-resource-more-info">
        <p class="site-resource-info-text">{{constants.subtitle2}}</p>
        <a href="/core/maps" class="text-link">{{constants.link2}}</a>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 site-resource-section">
      <div class="d-flex align-items-center site-resource-icon-wrapper">
        <img src="../assets/images/directory.svg" alt="Handbook icon" class="me-3">
        <h2>{{constants.sectionTitle3}}</h2>
      </div>
      <div class="site-resource-more-info">
        <p class="site-resource-info-text">{{constants.subtitle3}}</p>
        <a href="/core/core-directory" class="text-link">{{constants.link3}}</a>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid d-flex align-items-center" style="background-color:#F5F5F5">
  <div class="container services-block">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 justify-content-center align-items-center site-resource-section">
        <div class="">
          <h2 class="page-subheading">{{constants.sectionTitle4}}</h2>
        </div>
        <div class="location-title">
          <span>{{constants.description2}}</span>
        </div>
        <div class="site-resource-more-info">
          <p class="site-resource-info-text">
            {{constants.subtitle4}}
          </p>
          <a href="https://safetyontheset.com/" class="text-link" target="_blank">{{constants.link4}} </a>
          <a href="https://safetyontheset.com/" class="text-link" target="_blank"><img
              src="../assets/images/link-icon.svg" alt="Safety On the Set"></a>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 justify-content-center align-items-center site-resource-section">
        <div class="">
          <h2 class="page-subheading">{{constants.sectionTitle5}}</h2>
        </div>
        <div class="location-title">
          <span>{{constants.description2}}</span>
        </div>
        <div class="site-resource-more-info">
          <p class="site-resource-info-text">{{constants.subtitle5}}</p>
          <a href="https://food.wb.com/" class="text-link" target="_blank">{{constants.link5}}</a>
          <a href="https://food.wb.com/" class="text-link" target="_blank"><img src="../assets/images/link-icon.svg"
              alt="Food Service"></a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- center section starts -->
<ng-template #successTpl>
  <div class="success">{{addUserSuccess}}</div>
</ng-template>

<ng-template #dangerTpl>
  <div class="danger">{{addUserError}}</div>
</ng-template>